import React from 'react'
import { Link } from "react-router-dom";


const Hadear = () => {

  return (
    <>


      {/* <PopApp /> */}



      <button id="back-top" className="back-to-top">
        <i className="fa-regular fa-arrow-up" />
      </button>

      <div className="fix-area">
        <div className="offcanvas__info">
          <div className="offcanvas__wrapper">
            <div className="offcanvas__content">
              <div className="offcanvas__top mb-5 d-flex justify-content-between align-items-center">
                <div className="offcanvas__logo">
                  <Link to="/">
                    <img src="assets/img/svp/logo_1.jpeg" alt="logo-img" style={{ width: "80px", height: "80px", borderRadius: "5px" }} />
                    {/* <img src="assets/img/svp/logo_1.jpeg" alt="logo-img" style={{ width: "80px", height: "80px", borderRadius: "5px" }} /> */}
                  </Link>
                </div>
                <div className="offcanvas__close">
                  <button>
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>

              <div className="mobile-menu fix mb-3" />
              <div className="offcanvas__contact">
                <h4>Contact Info</h4>
                <ul>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon">
                      <i className="fal fa-map-marker-alt" />
                    </div>
                    <div className="offcanvas__contact-text">
                      <a href='https://share.google/UtLy4KFdIpQWtw3Xz' target="_blank"> Saraswati Vidyapeeth School Utaili, Satna </a>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="fal fa-envelope" />
                    </div>
                    <div className="offcanvas__contact-text">
                      <a href="mailto:svpsatna@gmail.com"><span className="mailto:svpsatna@gmail.com">svpsatna@gmail.com</span></a>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="fal fa-clock" />
                    </div>
                    <div className="offcanvas__contact-text">
                      <a target="_blank" to="#">Monday to Saturday </a>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="far fa-phone" />
                    </div>
                    <div className="offcanvas__contact-text">
                      <a href="tel:+91 7000664954">+91 7000664954</a>
                    </div>
                  </li>
                </ul>
                <div className="social-icon d-flex align-items-center">
                  <a href="https://www.instagram.com/saraswatiawasiyavidyapeeth?utm_source=ig_web_button_share_sheet&igsh=amh6a2twc3phNXl3" target="_blank"><i className="fa-brands fa-instagram" /></a>
                  <a href="https://www.youtube.com/@saraswatiawasiyavidyapeeth" target="_blank"><i className="fa-brands fa-youtube" /></a>
                  <a to="https://www.facebook.com/share/19cCH8TPEA/" target="_blank"><i className="fab fa-facebook-f" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="offcanvas__overlay" />

      <div className="header-top-section">
        <div className="container-fluid">
          <div className="header-top-wrapper">
            <ul className="contact-list">
              <li>
                <i className="fal fa-map-marker-alt" />
                <a href='https://share.google/UtLy4KFdIpQWtw3Xz' target="_blank"> Saraswati Vidyapeeth School Utaili, Satna </a>

              </li>
              <li>
                <i className="far fa-phone" />
                <a href="tel:+91 7000664954" className="link">+91 7000664954,  </a>
                <a href="tel:+91 6265386826" className="link">  +91 6265386826</a>
              </li>

            </ul>
            <div className="social-icon d-flex align-items-center">
              <span>Follow Us On:</span>
              <a href="https://www.instagram.com/saraswatiawasiyavidyapeeth?utm_source=ig_web_button_share_sheet&igsh=amh6a2twc3phNXl3" target="_blank"><i className="fa-brands fa-instagram" /></a>
              <a href="https://www.youtube.com/@saraswatiawasiyavidyapeeth" target="_blank"><i className="fa-brands fa-youtube" /></a>
              <a href="https://www.facebook.com/share/19cCH8TPEA/" target="_blank"><i className="fab fa-facebook-f" /></a>
              {/* <a to="#" target="_blank"><i className="fab fa-twitter" /></a> */}

            </div>
          </div>
        </div>
      </div>

      <header id="header-sticky" className="header-1">
        <div className="container-fluid">
          <div className="mega-menu-wrapper">
            <div className="header-main">
              <div className="header-left">
                <div className="logo">
                  <Link to="/" className="header-logo">
                    <img src="assets/img/svp/logo_1 - Copy.jpeg" alt="logo-img" style={{ width: "70px", height: "80px", borderRadius: "5px" }} />
                  </Link>
                  <Link to="/" className="header-logo">
                    <img src="assets/img/svp/logo_2.png" alt="logo-img" style={{ width: "60px", height: "80px", borderRadius: "5px" }} />
                  </Link>
                  <Link to="/" className="header-logo">
                    <img src="https://res.cloudinary.com/dnquglkeh/image/upload/v1771511772/%E0%A4%B8%E0%A4%B0%E0%A4%B8%E0%A5%8D%E0%A4%B5%E0%A4%A4%E0%A5%80_wdcxxe.png" alt="logo-img" style={{ width: "170px", height: "80px", borderRadius: "5px" }} />
                  </Link>
                </div>
              </div>
              <div className="mean__menu-wrapper" >
                <div className="main-menu">
                  <nav id="mobile-menu">
                    <ul>
                      <li className="has-dropdown active menu-thumb">
                        <Link to="/">
                          Home
                        </Link>

                      </li>
                      <li className="has-dropdown">
                        <Link to="/about">
                          About Us
                          <i className="fas fa-angle-down" />
                        </Link>
                        <ul className="submenu">
                          <li>
                            <Link to="/about">About Us</Link>
                          </li>
                          <li className="has-dropdown">
                            <Link to="/mission-vision">
                              Mission & Vision
                            </Link>
                          </li>
                          <li><Link to="/director-message">Director Message</Link></li>
                          <li><Link to="/our-team">Administrative Officer</Link></li>
                          <li><Link to="/our-faculty">Our Faculty</Link></li>
                        </ul>
                      </li>

                      <li>
                        <Link to="/facility">Facility</Link>
                      </li>
                      <li>
                        <Link to="/activities">Activities</Link>
                      </li>
                      {/* <li>
                        <a to="contact.html">Admission</a>
                      </li>
                      <li>
                        <a to="contact.html">Top Result</a>
                      </li> */}
                      <li>
                        <Link to="/gallery">Gallery</Link>
                      </li>
                      {/* <li>
                        <Link to="/blog">Blog</Link>
                      </li> */}
                      <li>
                        <Link to="/faq">FAQ's</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>
                      <a href="assets/img/svp/Brochure.pdf" style={{ marginTop: "10px" }} target="_blank" className="theme-btn text-center">
                        <span>Brochure<i className="fa-solid fa-arrow-right-long" /></span>
                      </a>


                    </ul>
                  </nav>
                </div>
              </div>
              <div className="header-right d-flex justify-content-end align-items-center">
                <div className="header__hamburger d-xl-none my-auto">
                  <div className="sidebar__toggle">
                    <i className="fas fa-bars" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

    </>
  )
}

export default Hadear